import ContactsItems from "../../../components/contacts/contact-items";
import ContactsContainer from "../../../components/contacts/contacts-container";
import Form from "../../../components/form/Form";
import {
  getContacts,
  updateContact,
  deleteContact,
} from "../../../apis/contactsApi";
import React from "react";
import Error from "../../../components/errors-messages/Error";

import { useState, useEffect } from "react";

// import "./NavigationItems.css";

function Contacts(props) {
  const [state, setState] = useState({
    isEditing: false,
    contacts: [],
    editContact: null,
    error: null,
  });

  useEffect(() => {
    loadPosts();
    // const socket = openSocket("https://shark-app-2ttko.ondigitalocean.app/website");

    // socket.on("posts", (data) => {
    //   if (data.action === "create") {
    //     addPost(data.post);
    //   } else if (data.action === "update") {
    //     updatePost(data.post);
    //   } else if (data.action === "delete") {
    //     loadPosts();
    //   }
    // });
  }, []);

  const loadPosts = async () => {
    const { data, error } = await getContacts();
    if (!data && error) {
      return setState((prevState) => {
        return {
          isEditing: false,
          contacts: [],
          editContact: null,
          error: error,
        };
      });
    }
    setState((prevState) => {
      return {
        ...prevState,
        contacts: data.contacts,
      };
    });
  };

  const startEditPostHandler = (postId) => {
    setState((prevState) => {
      const loadedContact = {
        ...prevState.contacts.find((p) => p._id === postId),
      };

      return {
        ...prevState,
        isEditing: true,
        editContact: loadedContact,
      };
    });
  };

  const cancelEditHandler = () => {
    setState((prevState) => {
      return { ...prevState, isEditing: false, editContact: null, error: null };
    });
  };

  const finishEditHandler = async (contactData) => {
    setState((prevState) => {
      return {
        ...prevState,
        editLoading: true,
      };
    });
    // Set up data (with image!)

    // const formData = new FormData();

    // formData.append("type", postData.type);
    // formData.append("name", postData.name);
    // formData.append("image", postData.image);
    let contactId = state.editContact ? state.editContact._id : null;

    const { data, error } = await updateContact(
      props.token,
      contactId,
      contactData
    );

    if (!data && error) {
      return setState((prevState) => {
        return {
          ...prevState,
          isEditing: false,
          editContact: null,
          // editLoading: false,
          error: error,
        };
      });
    }
    // const updatedContact = data.contact;
    const contact = {
      _id: data.contact._id,
      type: data.contact.type,
      name: data.contact.name,
      link: data.contact.link,
    };

    setState((prevState) => {
      // console.log(prevState.contacts.concat(contact));
      let updatedContacts;
      if (prevState.editContact) {
        updatedContacts = prevState.contacts.map((c) =>
          c._id === contact._id ? contact : c
        );
      } else {
        updatedContacts = prevState.contacts.concat(contact);
      }
      return {
        ...prevState,
        contacts: updatedContacts,
        isEditing: false,
        editContact: null,
        // editLoading: false,
      };
    });
  };

  const newPostHandler = () => {
    setState((prevState) => {
      return { ...prevState, isEditing: true };
    });
  };

  const deletePostHandler = async (postId) => {
    setState((prevState) => {
      return { ...prevState, postsLoading: true };
    });
    const { data, error } = await deleteContact(props.token, postId);
    if (!data && error) {
      return setState((prevState) => {
        return {
          ...prevState,
          isEditing: false,
          editContact: null,
          // editLoading: false,
          error: error,
        };
      });
    }
    loadPosts();
    setState((prevState) => {
      return { ...prevState, postsLoading: false };
    });
  };

  return (
    <>
      <Error error={state.error} onHandle={cancelEditHandler} />
      <Form
        editing={state.isEditing}
        currentItem={state.editContact}
        page={"Contact"}
        // loading={state.editLoading}
        onCancelEdit={cancelEditHandler}
        onFinishEdit={finishEditHandler}
      />
      <ContactsContainer onAddContact={newPostHandler} isAuth={props.isAuth}>
        {state.contacts.map((contact) => (
          <ContactsItems
            onStartEdit={startEditPostHandler.bind(this, contact._id)}
            key={contact._id}
            type={contact.type}
            name={contact.name}
            onDelete={deletePostHandler.bind(this, contact._id)}
            isAuth={props.isAuth}
          />
        ))}
      </ContactsContainer>
      ;
    </>
  );

  // props.isAuth && (
  //   <li className="navigation-item" key="logout">
  //     <button onClick={props.onLogout}>Logout</button>
  //   </li>
  // ),
}

export default Contacts;
